/**
*功能名称：必填
*创 建 人：弋强
*日    期：2022/08/18 16:19:29
*/
import { BaseApprove, ApproveData } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal } from "@newview/ui";
@Component({
    components: {

    }
})
export default class NoPage extends BaseApprove {
    init(approveData: ApproveData): void {
        
    }
    openModal(): void {

    }
    closeModal(): void {

    }
    pass(isEnd: boolean, approveData: ApproveData) {

    }
    return(isStart: boolean, approveData: ApproveData) {

    }

    //#region 接口定义区

    //#endregion 接口定义区

    //#region 变量定义区

    //#endregion 变量定义区

    //#region 事件定义区

    mounted() {
        //页面渲染完出发事件
    }

    //#endregion 事件定义区

    //#region 方法定义区

    //#endregion 方法定义区
}